<template>
  <div class="mt-5">
    <fee-configuration-form
      :is-active.sync="isAdding"
      :feeConfiguration="feeConfiguration"
      :url="url"
      @changed="feeConfigurationAdded"
    />
    <fee-configuration-form
      :is-active.sync="isEditing"
      :feeConfiguration="feeConfiguration"
      :feeRange="feeRange"
      :url="updateUrl"
      method="put"
      @changed="feeConfigurationUpdated"
    />
    <data-table
      title="Fee ranges"
      ref="table"
      :url="url"
      :headers="headers"
      :archive="false"
      item-key="id"
      searchable
    >
      <v-btn slot="action.icons" color="primary" @click="isAdding = true">
        Add fee Ranges
        <v-icon class="ml-2" color="light-blue lighten-4"> mdi-account-money</v-icon>
      </v-btn>
      <template slot="item.actions" slot-scope="{ item }">
        <v-btn small icon @click.stop="updateFeeConfiguration(item)">
          <v-icon>mdi-pencil-outline</v-icon>
        </v-btn>
        <v-btn small icon @click.stop="deleteFeeConfiguration(item)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </data-table>
  </div>
</template>
<script>
import FeeConfigurationForm from "./form";
export default {
  components: {
    FeeConfigurationForm,
  },
  props: {
    feeConfiguration: {
      required: true,
    },
    url: {
      required: true,
    },
  },
  data() {
    return {
      isAdding: false,
      isEditing: false,
      feeRange: null,
      updateUrl: "",
      headers: this.pairTableLabelWithValue({
        ID: "id",
        Min: "min",
        Max: "max",
        Value: "value",
        Actions: "actions",
      }),
    };
  },
  computed: {},
  watch: {
    url() {
      this.$nextTick(() => {
        this.$refs.table.fetchData();
      });
    },
  },
  methods: {
    feeConfigurationAdded({ message }) {
      this.isAdding = false;
      Notify.success(message);
      // refresh the table data
      this.$refs.table.fetchData();
    },
    feeConfigurationUpdated({ message }) {
      this.editingOffer = null;
      this.isUpdating = false;
      Notify.success(message);
      // refresh the table data
      this.$refs.table.fetchData();
    },
    updateFeeConfiguration(feeRange) {
      this.feeRange = Object.assign({}, feeRange);
      this.updateUrl = `${this.url}/${feeRange.id}`;
      this.isEditing = true;
    },
    async deleteFeeConfiguration(fee) {
      //   Notify.confirm(`Do you want to archive this value?`).then(() => {});
      const deleteUrl = this.url + "/" + fee.id;
      await Notify.confirm(`Do you want to archive this value?`).then(() => {
        this.$http
          .delete(deleteUrl)
          .then(({ message }) => {
            Notify.success(message);
            this.$refs.table.fetchData();
          })
          .catch((error) => {
            Notify.errorFromResponse(error, { close: true });
          });
      });
    },
  },
};
</script>
